import React from "react";
import PropTypes from "prop-types";
import useViewport from "../../Helpers/hooks/useViewport";

const Headline = (props) => {
    const { isDesktop } = useViewport();
    let { size } = props;
    if (props.resizable) {
        size = !isDesktop ? props.size : props.size - 1;
    }

    const HTMLTag = (props) => React.createElement(`h${size}`, props);
    return (
        <HTMLTag style={props.style} className={props.className}>
            {props.children}
        </HTMLTag>
    );
};

Headline.propTypes = {
    size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    resizable: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

Headline.defaultProps = {
    size: 3, // Mobile size
    resizable: false,
};

export default Headline;
